module.exports = __webpack_public_path__ + "media/images/sp/page_common/icon/icon_stores_reserve-c96eb93ed8abdc022f7ae04ea9953ea2.svg";